import { useState } from 'react'

import { PHASES } from '@/constants/search/federal/sbir'

import { useLocalSearch } from '@/hooks/search/useLocalSearch'

export const useSbirPhaseSearch = () => {
  const [query, setQuery] = useState<string>('')

  const { results: searchedItems } = useLocalSearch(query, PHASES)

  return {
    data: searchedItems.map((item) => item.item),
    query,
    setQuery,
  }
}
